module.exports = __webpack_public_path__ + "img/Kia_logo_300x300.ed649368.png";